import Header from "./Header";
import Footer from "./Footer";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  font-family: "SpoqaHanSansNeoRegular";
  flex-direction: column;
  align-items: center;
`;

const CommonContainer = ({ children, disabled, button, handleNextClick }) => {
  return (
    <Container>
      <Header button={button} />
      {children}
      <Footer disabled={disabled} handleNextClick={handleNextClick} />
    </Container>
  );
};



export default CommonContainer;
